// stylelint-disable declaration-no-important
// stylelint-disable no-descending-specificity
@import '../../style/index';

@include host {
  @include component-margin();

  rcm-headline {
    margin-top: rem-calc(32px);
    min-height: rem-calc(30px);
  }

  rcm-column:first-child {
    @include large-up() {
      padding-right: var(--spacings-xl) !important;
    }
  }

  rcm-column:nth-child(2) {
    @include large-up() {
      padding-right: calc((var(--spacings-xl) + var(--spacings-s)) / 2) !important;
      padding-left: calc((var(--spacings-xl) + var(--spacings-s)) / 2) !important;
    }
  }

  rcm-column:last-child {
    @include large-up() {
      padding-left: var(--spacings-xl) !important;
    }
  }

  .blocks {
    rcm-column {
      display: flex;
      align-items: start;
      flex-direction: column;

      --columnGap: var(--spacings-s);

      @include large-up() {
        --columnGap: var(--spacings-xl);
      }
    }

    &--with-offset {
      rcm-column:nth-child(2) {
        @include breakpoint($breakpoint-large) {
          margin-top: rem-calc(64px);
        }
      }

      rcm-column:nth-child(3) {
        @include breakpoint($breakpoint-large) {
          margin-top: calc(2 * (#{rem-calc(64px)}));
        }
      }
    }
  }

  a {
    @include copy-secondary();

    text-decoration: none;
  }

  p {
    @include copy-primary();

    &.content {
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical; /* stylelint-disable-line */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  rcm-generic-link {
    margin-top: 0;
  }

  .link-container {
    display: flex;
    align-items: center;

    rcm-button {
      &:first-of-type {
        margin-right: var(--spacings-s);
      }
    }
  }
}
